import FemaleAvatar from "./placeholders/FemaleAvatar";
import MaleAvatar from "./placeholders/MaleAvatar";
import NeutralAvatar from "./placeholders/NeutralAvatar";

// A custom avatar always takes precedence. Otherwise the mark is derived from
// the account's `sex`, with the neutral mark covering `null` — an account that
// never completed demographics.
//
// The API returns `avatar: { url }` or `avatar: null` and never a placeholder
// URL, so nothing here is ever fetched from the network for a placeholder.
export function resolvePlaceholder(sex) {
  if (sex === "MALE") {
    return MaleAvatar;
  }
  if (sex === "FEMALE") {
    return FemaleAvatar;
  }
  return NeutralAvatar;
}

export default function ProfileAvatar({
  avatarUrl = null,
  sex = null,
  size = 64,
  className = "",
}) {
  const dimension = { width: size, height: size };

  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        // Decorative: the surrounding row already names the field, so an
        // alt string here would only be repeated by a screen reader.
        alt=""
        width={size}
        height={size}
        style={dimension}
        className={`shrink-0 rounded-full object-cover ${className}`.trim()}
        data-testid="profile-avatar-image"
      />
    );
  }

  const Placeholder = resolvePlaceholder(sex);

  return (
    <Placeholder
      className={`shrink-0 rounded-full ${className}`.trim()}
      width={size}
      height={size}
      style={dimension}
      // Rendered inline, so there is no request and no layout shift.
      data-testid="profile-avatar-placeholder"
      data-placeholder={sex === "MALE" ? "male" : sex === "FEMALE" ? "female" : "neutral"}
    />
  );
}
